module.exports = __webpack_public_path__ + "static/media/wf.c942b078.svg";